import { isUserFromWebView } from '@libs/utils/helpers/webviewComunication';

export default function getRedlineAppName() {
  // isUserFromWebView is app version 5.x.x-
  // window.isNativeApp is app version 6.x.x+
  const typeName =
    isUserFromWebView() || window.isNativeApp ? 'mobile-app' : 'webapp';

  return `cp-${typeName}`;
}
